import PropTypes from 'prop-types';
import {labels} from '../../../../../../util/utils';

function ScotStrategy({strategyTypeId}) {
	return labels.strategyType[strategyTypeId]?.strategyTypeName || labels.notSelected;
}

ScotStrategy.propTypes = {
	count: PropTypes.number
};

export default ScotStrategy;
